/* @jsx h */
import { defineComponent, h } from "vue";
import { release, lemmonEnv } from "../../../../version";

export const ReleaseInfo = defineComponent({
  name: "ReleaseInfo",
  setup() {
    const app = lemmonEnv?.app ?? null;
    const appDetails = [
      app?.version ? `v${app.version}` : null,
      app?.build ? `build ${app.build}` : null,
    ].filter(Boolean);

    return () => (
      <li class="pointer-events-none px-3 py-1.5">
        <div class="!flex !min-h-0 !w-full items-center gap-1.5 !p-0 text-[9px] leading-none text-base-content/25">
          <span class="material-symbols-outlined shrink-0 text-[12px]">
            deployed_code
          </span>
          <span class="min-w-0 truncate text-[10px] text-base-content/30">
            {release}
          </span>
          {import.meta.env.VITE_ENV && (
            <span class="shrink-0 font-medium uppercase tracking-wide">
              {import.meta.env.VITE_ENV}
            </span>
          )}
          {appDetails.length > 0 && (
            <span class="shrink-0">App {appDetails.join(" · ")}</span>
          )}
          {lemmonEnv?.ota?.createdAt && (
            <span class="min-w-0 truncate">OTA {lemmonEnv.ota.createdAt}</span>
          )}
        </div>
      </li>
    );
  },
});
